import { Repository } from '@/forms/api/repository-factory';
import getParams from '@/forms/helpers/get-params';
import { AUTO_LOAN_DETAILS } from '@/forms/constants/services';

const resource = '/automation/api/v1.0';

export default {
    getAutoLoanDetails(payload) {
        return Repository.post(`${resource}`, payload, {
            params: getParams(AUTO_LOAN_DETAILS),
        });
    },
};